import { useNode } from '@craftjs/core';
import {
  FormCheckboxGroupInputComponent,
  FormCheckboxGroupInputProps,
} from 'src/features/generalForms/builder/types/CheckboxGroupInput';
import {
  TitlePanel,
  AnswersPanel,
  LayoutPanel,
  ValidationPanel,
  LogicPanel,
} from 'src/features/generalForms/builder/layout/panels';
import { FormFieldOption } from 'src/features/generalForms/builder/types/BaseControlTypes';
import { AppCheckboxGroupField } from 'src/features/generalForms/uikit/fields/checkboxes/checkboxes';
import { useDataKeyValidation } from 'src/features/generalForms/builder/validationContext/helper';

export const FormCheckboxGroupInput: FormCheckboxGroupInputComponent = (props) => {
  const {
    actions: { setProp },
    connectors: { connect, drag },
    styles,
  } = useNode((node) => ({
    styles: node.data.custom,
  }));

  const validationResult = useDataKeyValidation();

  const { paddingBottom, paddingLeft, paddingRight, paddingTop, ...restStyles } = styles;

  return (
    <div
      ref={(ref: HTMLDivElement) => connect(drag(ref))}
      style={{ paddingBottom, paddingLeft, paddingRight, paddingTop }}
    >
      <AppCheckboxGroupField<FormFieldOption, 'key'>
        style={restStyles}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        valueField={'key'}
        labelField={'value'}
        options={props.options ?? []}
        disabled={props.disabled}
        value={props.defaultValue ?? []}
        onChange={(newValue) => {
          setProp(
            (p: FormCheckboxGroupInputProps) =>
              (p.defaultValue = newValue && newValue?.length > 0 ? newValue : undefined),
            500,
          );
        }}
        errorProps={{ errors: validationResult?.message }}
      />
    </div>
  );
};

export const FormCheckboxGroupInputSettings = () => (
  <>
    <TitlePanel sections={['Title', 'Description', 'Prefix', 'Tooltip', 'DataKey']} />
    <AnswersPanel sections={['NoAnswerScore']} />
    <LayoutPanel sections={['ContentLayout', 'Paddings']} />
    <ValidationPanel />
    <LogicPanel sections={['Visible', 'Enable']} />
  </>
);

FormCheckboxGroupInput.craft = {
  displayName: 'Checkboxes',
  rules: { canDrag: () => true },
  related: { settings: FormCheckboxGroupInputSettings },
};
